// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kyc-card {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 20px;
    padding: 2.5rem;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.07);
    max-width: 500px;
    width: 100%;
    margin: 2rem auto;
    text-align: center;
    transition: all 0.3s ease;
}

.kyc-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 40px 0 rgba(31, 38, 135, 0.1);
}

.kyc-icon-wrapper {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #f7bd20 0%, #f39c12 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    color: white;
    box-shadow: 0 4px 15px rgba(247, 189, 32, 0.3);
}

.kyc-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 0.75rem;
}

.kyc-description {
    font-size: 0.95rem;
    color: #666;
    line-height: 1.6;
    margin-bottom: 2rem;
}

.kyc-button {
    background: #1a1a1a;
    color: white;
    border: none;
    padding: 0.9rem 2rem;
    border-radius: 12px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.kyc-button:hover {
    background: #333;
    transform: scale(1.02);
}

.kyc-button:disabled {
    background: #999;
    cursor: not-allowed;
    transform: none;
}

.kyc-status-badge {
    display: inline-block;
    padding: 0.5rem 1rem;
    border-radius: 30px;
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
}

.status-not_started {
    background: #f3f4f6;
    color: #6b7280;
}

.status-initiating {
    background: #eff6ff;
    color: #3b82f6;
}

.status-in_progress {
    background: #fffbeb;
    color: #d97706;
}

.status-completed {
    background: #f0fdf4;
    color: #16a34a;
}

.status-failed {
    background: #fef2f2;
    color: #dc2626;
}

.loading-spinner-kyc {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid white;
    border-radius: 50%;
    animation: kyc-spin 0.8s linear infinite;
}

@keyframes kyc-spin {
    to {
        transform: rotate(360deg);
    }
}

.success-checkmark {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #16a34a;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes scaleIn {
    from {
        transform: scale(0);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.kyc-error-message {
    color: #dc2626;
    font-size: 0.85rem;
    margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/KycVerification.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;IACnC,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,gDAAgD;IAChD,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,2BAA2B;IAC3B,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,+DAA+D;AACnE;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".kyc-card {\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 20px;\n    padding: 2.5rem;\n    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.07);\n    max-width: 500px;\n    width: 100%;\n    margin: 2rem auto;\n    text-align: center;\n    transition: all 0.3s ease;\n}\n\n.kyc-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 12px 40px 0 rgba(31, 38, 135, 0.1);\n}\n\n.kyc-icon-wrapper {\n    width: 80px;\n    height: 80px;\n    background: linear-gradient(135deg, #f7bd20 0%, #f39c12 100%);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1.5rem;\n    color: white;\n    box-shadow: 0 4px 15px rgba(247, 189, 32, 0.3);\n}\n\n.kyc-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1a1a1a;\n    margin-bottom: 0.75rem;\n}\n\n.kyc-description {\n    font-size: 0.95rem;\n    color: #666;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n}\n\n.kyc-button {\n    background: #1a1a1a;\n    color: white;\n    border: none;\n    padding: 0.9rem 2rem;\n    border-radius: 12px;\n    font-weight: 600;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.kyc-button:hover {\n    background: #333;\n    transform: scale(1.02);\n}\n\n.kyc-button:disabled {\n    background: #999;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.kyc-status-badge {\n    display: inline-block;\n    padding: 0.5rem 1rem;\n    border-radius: 30px;\n    font-size: 0.85rem;\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n}\n\n.status-not_started {\n    background: #f3f4f6;\n    color: #6b7280;\n}\n\n.status-initiating {\n    background: #eff6ff;\n    color: #3b82f6;\n}\n\n.status-in_progress {\n    background: #fffbeb;\n    color: #d97706;\n}\n\n.status-completed {\n    background: #f0fdf4;\n    color: #16a34a;\n}\n\n.status-failed {\n    background: #fef2f2;\n    color: #dc2626;\n}\n\n.loading-spinner-kyc {\n    width: 20px;\n    height: 20px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top: 2px solid white;\n    border-radius: 50%;\n    animation: kyc-spin 0.8s linear infinite;\n}\n\n@keyframes kyc-spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.success-checkmark {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background: #16a34a;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1.5rem;\n    animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n@keyframes scaleIn {\n    from {\n        transform: scale(0);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.kyc-error-message {\n    color: #dc2626;\n    font-size: 0.85rem;\n    margin-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
